module.exports = __webpack_public_path__ + "img/no-backdrop.da67264a.png";